import React from 'react'

import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'

type ConfirmModalProps = {
  open: boolean
  title: string
  onClose: () => void
  onConfirm: () => void
  content?: React.ReactNode
  disabled?: boolean
  loading?: boolean
}

const ConfirmModal = ({ onClose, onConfirm, open, title, content, disabled, loading }: ConfirmModalProps) => (
  <Dialog onClose={onClose} open={open}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>{content}</DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button disabled={disabled} loading={loading} onClick={onConfirm}>
        Confirm
      </Button>
    </DialogActions>
  </Dialog>
)

export default ConfirmModal
